const purchaseTypes = {
  PURCHASE_OPEN_MODAL: 'PURCHASE_OPEN_MODAL',
  PURCHASE_CLOSE_MODAL: 'PURCHASE_CLOSE_MODAL'
}

export default purchaseTypes
